import { APP_ENVIRONMENT } from '../global';
import { ActionIdMappingProd } from './actions.prod';
import { ActionIdMappingQa } from './actions.qa';

const getActionIdMapping = () => {
  switch (APP_ENVIRONMENT) {
    case 'production':
      return ActionIdMappingProd;
    default:
      return ActionIdMappingQa;
  }
};

export const ActionsConstants = {
  ...getActionIdMapping(),
};

export default ActionsConstants;
